<template>
  <v-layout class="detail-columns">
    <v-flex class="left-column" v-if="inspection">
      <ReportList
        :hg-folder-id="folderId"
        :hg-report-anchor="reportAnchor"
        :hg-report-block="inspection.folderStatus.blocked"
        :hg-reports="inspection.reports"
        class="left-item" />
      <MyTeam
        :hg-agents="inspection.agents"
        :hg-inspectors="inspection.inspectors"
        class="left-item team" />
    </v-flex>
    <v-flex class="right-column">
      <AccountDetail
        :hg-payments="inspectionPayments"
        :hg-agreements="inspection.agreements"
        :hg-folder-id="folderId"
        :hg-folder-status="inspection.folderStatus"
        :hg-company-id="inspection.company.id"/>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

import AccountDetail from './AccountDetail.vue';
import MyTeam from './MyTeam.vue';
import ReportList from './ReportList.vue';

export default {
  components: {
    AccountDetail,
    MyTeam,
    ReportList,
  },
  props: {
    folderId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      reportAnchor: 'report-anchor',
    };
  },
  computed: {
    ...mapState('Inspection', {
      inspection: state => state.inspection,
    }),
    ...mapGetters('Inspection', [
      'inspectionAcceptsOnlinePayment',
    ]),
    // @TODO refactor consumer component `hg-account-detail`
    // to use individual props instead of object
    inspectionPayments() {
      const output = {
        acceptsOnlinePayment: false,
        invoiceDocuments: [],
        outstandingBalance: 0,
        paid: [],
      };

      const { inspection } = this;
      output.acceptsOnlinePayment = this.inspectionAcceptsOnlinePayment;
      output.invoiceDocuments = inspection.invoiceDocuments;
      output.outstandingBalance = inspection.outstandingBalance;
      output.payments = inspection.payments;

      return output;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/vars/theme';

.detail-columns {
  background-color: $theme-color-white;
  margin: 0 auto;
  padding-left: 50px;
  padding-right: 50px;
  padding-top: 50px;
  position: relative;
  width: 90%;
}

.left-column {
  background-color: $theme-color-white;
  margin-bottom: 40px;
}

.left-item {
  border-bottom: solid 1px rgba($theme-color-black, 0.15);
  margin-right: 50px;
  padding-bottom: 30px;
  padding-top: 40px;

  &:first-child {
    padding-top: 0;
  }

  &:last-child {
    border-bottom: 0;
  }
}

.right-column {
  background-color: $theme-color-white;
  flex: 0 0 350px;
}

@media all and (max-width: 655px) {
  .detail-columns {
    padding: 0;
    top: 0;
    width: 100%;
  }
}

@media all and (max-width: 1150px) {
  .detail-columns {
    display: run-in; /* fix for ie 11 */
    flex-direction: column;
  }
}
</style>
